<template>
  <div>
    <!-- Subórdenes -->
    <v-list v-if="suborders.length > 0" class="receivable__container">
      <div
        v-for="(suborder, key) in suborders"
        :key="`prouct-${key}`"
        class="receivable__suborders"
        color="auxtext"
      >
        <!-- Datos primarios de la suborden -->
        <div class="suborder__head">
          <div>
            <!-- Nombre de la suborden -->
            <p v-if="suborder.name" class="head-title">
              {{ suborder.name }}
            </p>

            <!-- Código de la suborden -->
            <p v-if="suborder.code" class="head-title">
              {{ `${$tc('code', 2)}: ` }}
              <span class="text-aux">{{ suborder.code }}</span>
            </p>
          </div>

          <!-- Botones para imprimir factura y agregar pagos -->
          <div class="d-flex g-1 mt-3 mt-md-0">
            <!-- Imprimir factura -->
            <v-tooltip v-if="showInvoice(suborder.orderStatus)" bottom>
              <template v-slot:activator="{ on }">
                <i-btn
                  color="primary"
                  icon="fa-file-pdf"
                  outlined
                  :title="$t('print', { value: $t('invoice') })"
                  v-on="on"
                />
              </template>
              <!-- Imprimir factura aún no hace nada -->
              <!--  @click="openInvoice(suborder.pk, suborder.code)" -->
            </v-tooltip>

            <!-- Ir a cuentas por cobrar -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <i-btn
                  color="secondary"
                  icon="fa-file-invoice"
                  outlined
                  :loading="loadingRedirect"
                  :title="$t('receivable')"
                  @click="getReceivable(suborder.order)"
                  v-on="on"
                />
              </template>
            </v-tooltip>
          </div>
        </div>

        <!-- Detalles de la orden -->
        <v-row class="invoice--suborders-body">
          <!-- Nombre del producto -->
          <v-col cols="12" md="3">
            <p class="body-title">{{ $tc('product', 1) }}:</p>
            <p class="body-text">{{ suborder.own_prod }}</p>
          </v-col>

          <!-- Cantidad del producto -->
          <v-col class="flex-grow-1" cols="12" md="auto">
            <p class="body-title">{{ `${$tc('amount', 2)}: ` }}</p>
            <p class="body-text">
              {{ suborder.quantity }}
            </p>
          </v-col>

          <!-- Precio del producto -->
          <v-col class="flex-grow-1" cols="12" md="auto">
            <p class="body-title">{{ `${$tc('price', 1)}: ` }}</p>
            <p class="body-text">
              <i-money :value="suborder.price" mode="text" />
            </p>
          </v-col>

          <!-- Subtotal del producto -->
          <v-col class="flex-grow-1" cols="12" md="auto">
            <p class="body-title">{{ `${$tc('subtotal', 1)}: ` }}</p>
            <p class="body-text">
              <i-money
                :value="Number(suborder.subtotal) + Number(suborder.discount)"
                mode="text"
              />
            </p>
          </v-col>

          <!-- Descuento del producto -->
          <v-col v-if="suborder.discount > 0" cols="12" md="auto">
            <p class="body-title red--text">
              {{ `${$tc('discount', 1)}: ` }}
            </p>
            <p class="body-text red--text">
              <i-money :value="suborder.discount" mode="text" />
            </p>
          </v-col>

          <!-- Impuesto del producto -->
          <v-col class="flex-grow-1" cols="12" md="auto">
            <p class="body-title">
              {{ `${$tc('tax', 1)}: ` }}
            </p>
            <p class="body-text">
              <i-money :value="suborder.tax" mode="text" />
            </p>
          </v-col>

          <!-- Total del producto -->
          <v-col class="flex-grow-1" cols="12" md="auto">
            <p class="body-title">
              {{ `${$tc('total', 1)}: ` }}
            </p>
            <p class="body-text">
              <i-money :value="suborder.total" mode="text" />
            </p>
          </v-col>
        </v-row>
      </div>
    </v-list>

    <!-- Mensaje si no hay subórdenes -->
    <div v-else class="receivable__no-suborders">
      <p class="receivable__text grey--text">
        {{ $t('select_prod') }}
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    order: {
      type: Number,
      required: true
    },
    customerData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      suborders: [],
      dialog: false,
      loadingRedirect: false,
      invoice: {
        pk: 0,
        code: ''
      }
      // balance: '',
      // date: '',
      // extraInformation: {},
      // invoice_number: '',
      // order: '',
      // pk: '',
      // status: '',
      // subtotal: '',
      // tax: '',
      // total: ''
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      company: 'company/getCompanyData'
    }),
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        suborders:
          this.getPermissions([`sales.view_orderproduct`]) &&
          this.getPermissions([`sales.view_orderstatus`]) &&
          this.getPermissions([`sales.view_orderchangeprice`]) &&
          this.getPermissions([`sales.view_imageapproval`]) &&
          this.getPermissions([`sales.view_imageparameters`]) &&
          this.getPermissions([`sales.view_typedate`]) &&
          this.getPermissions([`sales.view_suborderdate`]) &&
          this.getPermissions([`sales.view_orderdetails`]) &&
          this.getPermissions([`product.view_productiondetails`])
      }
    }
  },
  methods: {
    async getSuborders() {
      this.loading = true
      try {
        const suborders = await this.$api.sale.suborder.show({
          pk: this.order,
          opt: { params: { order: true } }
        })
        this.suborders = suborders.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    openInvoice(suborderPK, suborderCode = '') {
      this.invoice.pk = suborderPK
      this.invoice.code = suborderCode
      this.dialog = true
    },
    /**
     * Método que valida el estado en el que está una suborden para mostrar u
     * ocultar los botones de facturación.
     *
     * @returns {Boolean} La suborden está en un estado de la fase final
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    showInvoice(suborderState = '') {
      return (
        suborderState === 'production - ready_to_deliver' ||
        suborderState === 'delivery - at_home' ||
        suborderState === 'delivery - pickup'
      )
    },
    /**
     * Método que consulta la cuenta por cobrar que tiene una orden de venta
     * y luego redirecciona a esa cuenta por cobrar
     *
     * @param {Number} receivable        ID de la cuenta por cobrar
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getReceivable(orderPK) {
      this.loadingRedirect = true
      await this.$api.invoice.receivable
        .byOrder({
          pk: orderPK
        })
        .then((response) => {
          this.changeRoute(response.data.pk)
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.loadingRedirect = false
        })
    },
    /**
     * Método para redireccionar la aplicación a una cuenta por cobrar
     * específica.
     *
     * @param {Number} receivable        ID de la cuenta por cobrar
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    changeRoute(receivablePK) {
      this.$router.push({
        name: 'receivable-pk',
        params: {
          pk: this.codification({ code: receivablePK })
        }
      })
    }
  },
  mounted() {
    this.getSuborders()
  }
}
</script>
<style lang="sass">
.v-list.receivable__container
  // ------------------------------------
  // Contenedor del listado de subórdenes
  // ------------------------------------
  background-color: transparent

.receivable__suborders
  // ---------------------
  // Listado de subórdenes
  // ---------------------
  border-radius: 10px
  margin-bottom: 15px
  padding: 0 .5rem

.theme--light
  .receivable__suborders
    background-color: rgb(0 0 0 / 3%)
    border: 1px solid rgb(0 0 0 / 0.26)
    border-left: 5px solid var(--v-primary-base)

.theme--dark
  .receivable__suborders
    background-color: rgb(40 40 40)
    border: 1px solid rgb(255 255 255 / 0.16)
    border-left: 5px solid var(--v-primary-base)

.receivable__suborders
  .suborder__head
    // -------------------------
    // Cabecera de cada suborden
    // -------------------------
    display: flex
    justify-content: space-between
    padding: 1rem .5rem
    align-items: flex-start
    @media (800px > width)
      flex-direction: column
    .head-title
      // ------------------------------
      // Nombre y código de la suborden
      // ------------------------------
      color: var(--v-primary-base)
      font-family: "Roboto", sans-serif
      font-size: 1.25rem
      font-weight: 900
      letter-spacing: 0.0125em
      line-height: 2rem
      margin-bottom: 0
      @media (600px > width)
        font-size: 1rem
        letter-spacing: 0.009375em
        line-height: 1.75rem

.invoice--suborders-body
  // ----------------------------
  // Información de cada suborden
  // ----------------------------
  margin: 0
  margin-bottom: 1rem
  border-radius: 10px
  .body-title
    color: var(--v-primary-base)
    font-size: .9rem
    margin-bottom: 0
    font-weight: 500
  .body-text
    font-size: 1rem
    font-weight: 400

.receivable__no-suborders
  // ---------------------------------
  // Aviso de cotización sin productos
  // ---------------------------------
  padding-top: 50px
  padding-bottom: 50px
  margin-bottom: 0
  background-color: var(--v-auxbg-base)
  border-radius: 10px
  & > .receivable__text
    // ---------------
    // Texto del aviso
    // ---------------
    font-size: 24px
    font-weight: bold
    text-align: center
</style>
